import React, { useState, useEffect } from "react";
import axios from "axios";
const { getNewYorkDateTime } = require("../utils/dateUtils");
export default function AgentsWithFiltersAndUpdate() {
const [, setAgents] = useState([]); // ignore state, only setter

  const [filtered, setFiltered] = useState([]);   // filtered agents
  const [users, setUsers] = useState([]);         // dropdown users
  const [loading, setLoading] = useState(false);

  // Filters
  const [phone, setPhone] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Dropdown selection
  const [selectedUser, setSelectedUser] = useState("");

  // Checkbox selection
  const [selectedAgents, setSelectedAgents] = useState([]); // store _ids

  // ✅ Fetch all users for dropdown
 useEffect(() => {
  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");
      const allUsers = res.data || [];
      // ✅ keep only users with role === "Assessor"
      const assessors = allUsers.filter(
        (u) => (u.role || "").trim().toLowerCase() === "assessor"
      );
      setUsers(assessors);
    } catch (err) {
      console.error("❌ Error fetching users:", err);
    }
  };
  fetchUsers();
}, []);


//  const fetchTodaySales = async () => {
//   try {
//     setLoading(true);
//     const res = await axios.get("https://crm-server-htk6.vercel.app/api/agents");

//     const today = new Date();
//     const todayDateOnly = today.toLocaleDateString();

//     const todaySales = (res.data || []).filter((a) => {
//       const isSale = (a.disposition || "").trim().toLowerCase() === "sale";
//       if (!a.verifiedDate) return false;

//       const verifiedDate = new Date(a.verifiedDate);
//       const verifiedDateOnly = verifiedDate.toLocaleDateString();

//       return isSale && verifiedDateOnly === todayDateOnly;
//     });

//     setAgents(todaySales);
//     setFiltered(todaySales);
//   } catch (err) {
//     console.error("❌ Error fetching agents:", err);
//   } finally {
//     setLoading(false);
//   }
// };



// useEffect(() => {
//   fetchTodaySales();
// }, []);

const fetchTodaySales = async () => {
  try {
    setLoading(true);
    const res = await axios.get(
      "https://crm-server-htk6.vercel.app/api/agents/today-sales"
    );

    setAgents(res.data.agents);
    setFiltered(res.data.agents);
  } catch (err) {
    console.error("❌ Error fetching agents:", err);
  } finally {
    setLoading(false);
  }
};



//   // ✅ Apply filters → fetch ALL Sale data and filter client side
// const applyFilters = async () => {
//   try {
//     setLoading(true);
//     const res = await axios.get("https://crm-server-htk6.vercel.app/api/agents");
//     let data = (res.data || []).filter(
//       (a) => (a.disposition || "").trim().toLowerCase() === "sale"
//     );

   

//     // 📞 Phone filter
//     if (phone.trim()) {
//       data = data.filter((a) =>
//         (a.phone || "").toString().includes(phone.trim())
//       );
//     }

//     // 📅 Date range filter (submittedDate)
//     if (fromDate && toDate) {
//       const from = new Date(fromDate).setHours(0, 0, 0, 0);
//       const to = new Date(toDate).setHours(23, 59, 59, 999);
//       data = data.filter((a) => {
//         if (!a.submittedDate) return false;
//         const d = new Date(a.submittedDate).getTime();
//         return d >= from && d <= to;
//       });
//     }

//     setAgents(data);
//     setFiltered(data);
//     setSelectedAgents([]); // reset checkboxes
//   } catch (err) {
//     console.error("❌ Error applying filters:", err);
//   } finally {
//     setLoading(false);
//   }
// };


const applyFilters = async () => {
  try {
    setLoading(true);

    const params = {
      phone: phone || "",
      fromDate: fromDate || "",
      toDate: toDate || ""
    };

    const res = await axios.get(
      "https://crm-server-htk6.vercel.app/api/agents/sales-filter-verified",
      { params }
    );

    const data = res.data.agents || [];
    setAgents(data);
    setFiltered(data);
    setSelectedAgents([]); // reset checkboxes

  } catch (err) {
    console.error("❌ Error applying filters:", err);
    alert("Error fetching filtered sales");
  } finally {
    setLoading(false);
  }
};


  // ✅ Handle checkbox toggle
  const toggleSelect = (id) => {
    setSelectedAgents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // ✅ Select All / Deselect All
  const toggleSelectAll = () => {
    if (selectedAgents.length === filtered.length) {
      setSelectedAgents([]);
    } else {
      setSelectedAgents(filtered.map((a) => a._id));
    }
  };

  
//   // ✅ Update assignedQAUser for all checked agents
//   const updateAgents = async () => {
//   if (!selectedUser) {
//     alert("⚠️ Please select a user from dropdown");
//     return;
//   }
//   if (selectedAgents.length === 0) {
//     alert("⚠️ Please select at least one agent");
//     return;
//   }

//   try {
//     setLoading(true);

//     const today = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });


//     await Promise.all(
//       selectedAgents.map((id) =>
//         axios.put(`https://crm-server-htk6.vercel.app/api/agents/${id}`, {
//           assignedQAUser: selectedUser,
//           assignedQADate: today,       // ✅ add/update current date
//         })
//       )
//     );

//     alert("✅ Assigned QA User & Date updated successfully!");

//     // 🔄 refresh list to show changes
//    // applyFilters();
//   } catch (err) {
//     console.error("❌ Error updating agents:", err);
//     alert("❌ Failed to update selected agents");
//   } finally {
//     setLoading(false);
//   }
// };



// Update selected agents
// Update selected agents
const updateAgents = async () => {
  if (!selectedUser) {
    alert("⚠️ Please select a user from dropdown");
    return;
  }
  if (selectedAgents.length === 0) {
    alert("⚠️ Please select at least one agent");
    return;
  }

  const alreadyAssigned = (filtered || []).filter((a) =>
  selectedAgents.includes(a._id) &&
  a.assignedQAUser &&
  a.assignedQAUser.trim() !== ""
);


  if (alreadyAssigned.length > 0) {
    const confirmUpdate = window.confirm(
      `⚠️ ${alreadyAssigned.length} selected records are already assigned.\n\n` +
      `Do you want to overwrite and reassign them?`
    );

    if (!confirmUpdate) {
      return; // ❌ stop update
    }
  }

  try {
    setLoading(true);

    // const today = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
    await Promise.all(
      selectedAgents.map((id) =>
        axios.put(`https://crm-server-htk6.vercel.app/api/agents/${id}`, {
          assignedQAUser: selectedUser,
          assignedQADate: getNewYorkDateTime(),
        })
      )
    );

    alert("✅ Assigned QA User & Date updated successfully!");

    // 🔄 REFRESH TABLE
    fetchTodaySales();

  } catch (err) {
    console.error("❌ Error updating agents:", err);
    alert("❌ Failed to update selected agents");
  } finally {
    setLoading(false);
  }
};





  return (
    <div style={{ padding: "20px" }} className="allforms-container">
      <h2>Assessor QA Task List</h2>

      {/* ---- Filter Inputs ---- */}
      <div
        className="form-row"
        style={{
          marginBottom: "15px",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <input
          type="text"
          placeholder="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        <button className="btn save" onClick={applyFilters}>
          Search
        </button>
      </div>

      {/* ---- User Dropdown + Update Button ---- */}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="">Select QA User</option>
          {users.map((u) => (
            <option key={u._id} value={`${u.firstName} ${u.lastName}`}>
              {u.firstName} {u.lastName}
            </option>
          ))}
        </select>

        <button className="btn save" onClick={updateAgents}>
          Update Selected
        </button>
      </div>

      {loading ? (
        <p>⏳ Loading...</p>
      ) : (
        <div
  style={{
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "600px",  // 👈 adjust height as needed
  }}
>

          <table className="allforms-agent-table" style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={toggleSelectAll}
                    checked={
                      filtered.length > 0 &&
                      selectedAgents.length === filtered.length
                    }
                  />
                </th>
                {/* <th>_id</th> */}
                   <th>CustomerID</th>
                <th>Assigned QA User</th>
                 <th>Final Disposition</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Lead Source</th>
                <th>Campaign</th>
                <th>Address</th>
                <th>City</th>
                {/* <th>Submitted Date</th>
                <th>Verified Date</th> */}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No records found
                  </td>
                </tr>
              ) : (
                filtered.map((a) => (
                  <tr key={a._id} style={{ borderBottom: "1px solid #ddd" }}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedAgents.includes(a._id)}
                        onChange={() => toggleSelect(a._id)}
                      />
                    </td>
 <td>{a.CustomerID || ""}</td>
                    <td>{a.assignedQAUser || ""}</td>
                                        <td>{a.finalDisposition}</td>
                    <td>{a.firstName || ""}</td>
                    <td>{a.lastName || ""}</td>
                    <td>{a.phone || ""}</td>
                    <td>{a.leadSource || ""}</td>
                    <td>{a.campaign || ""}</td>
                    <td>{a.address || ""}</td>
                    <td>{a.city || ""}</td>
                    {/* <td>
                      {a.submittedDate
                        ? new Date(a.submittedDate).toLocaleString()
                        : ""}
                    </td>
                    <td>
                      {a.verifiedDate
                        ? new Date(a.verifiedDate).toLocaleString()
                        : ""}
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
